import * as THREE from 'three'

export default class Frame {
  public readonly scale: number = 0.025
  public readonly texture: THREE.Texture
  public constructor (
    public readonly width: number = 320,
    public readonly height: number = 320,
    public readonly grayscale: boolean = false,
    public readonly attachedTo: HTMLDivElement = document.createElement('div')
  ) {
    const loader = new THREE.TextureLoader()
    const img = this.grayscale ? '/static/order/osb_white.jpg' : '/static/order/osb.jpg'
    this.texture = loader.load(img)
  }

  public attach (canvas: HTMLCanvasElement): void {
    while (this.attachedTo.firstChild) {
      this.attachedTo.removeChild(this.attachedTo.firstChild)
    }
    this.attachedTo.appendChild(canvas)
  }

  public snapshot (): Promise<HTMLImageElement> {
    const canvas = this.attachedTo.querySelector('canvas')
    if (canvas === null) {
      throw new Error('Invalid state')
    }
    return new Promise((resolve, reject) => {
      const options = {
        checkBounce: 6,
        checkLimit: 100,
        interval: 100
      }
      let prevSize = 0
      let same = 0
      const image = new Image()
      let timer: number | undefined
      image.onload = function () {
        if (prevSize === image.src.length) {
          same++
        }
        prevSize = image.src.length
        if (same > options.checkBounce || same > options.checkLimit) {
          clearInterval(timer)
          return resolve(image)
        }
      }
      timer = setInterval(() => {
        image.src = ''
        image.src = canvas.toDataURL('image/jpeg', 0.6)
      }, options.interval)
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/Order/Components/Three/Frame.ts